import { PropsWithChildren } from "react";
import "./SubmitLock.scss";

/**
 * Locks every input of a form while its submit request is in flight
 * (ui-design-principle-modals-dialogs): native inputs, buttons and textareas
 * inherit `disabled` from the fieldset, and pointer events are blocked so
 * custom controls (antd / react-select) cannot be changed either. Links
 * outside the fieldset stay usable. Unlocks when `locked` turns false again
 * (e.g. after a failed request), so the user can correct and retry.
 */
export function SubmitLock({
    locked,
    className,
    children,
}: PropsWithChildren<{ locked: boolean; className?: string }>) {
    return (
        <fieldset
            className={`submitLock${locked ? " submitLock--locked" : ""}${className ? ` ${className}` : ""}`}
            disabled={locked}
            aria-busy={locked}
            data-testid="submit-lock"
        >
            {children}
        </fieldset>
    );
}
